import { axiosPrivate } from '@app/dashboard/tools/axios/axiosInstance';

export const shareSinglePaymentLink = (payload: {
  share_with: string[];
  multiple_link_id: string;
}) => {
  return axiosPrivate.post(
    `/dashboard/api/v1/payment-links/share-link`,
    payload
  );
};
